import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const SignalRDetailsActiveColumns: DataGridActiveColumns = {
  RemoteIpAddress: true,
  TimeStamp: true,
  ConnectionType: true,
  SignalRClientId: true,
  Status: true,
  EmailAddress: true,
};

export const SignalRDetailHeaders = [
  {
    caption: 'Log Date',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'TimeStamp',
    dataType: 'datetime',
    width: '15%',
  },
  {
    caption: 'Status',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'Status',
    dataType: 'string',
    width: '12%',
  },
  {
    caption: 'Protocol',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ConnectionType',
    dataType: 'string',
    width: '12%',
  },
  {
    caption: 'IP Address',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'RemoteIpAddress',
    dataType: 'string',
    width: '12%',
  },
  {
    caption: 'Email Address',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'EmailAddress',
    dataType: 'string',
    width: '24%',
  },
  {
    caption: 'Client Id',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'SignalRClientId',
    dataType: 'string',
    width: '25%',
  },
];

export const SignalRDetailsBaseColumns = {
  TimeStamp: {
    field: 'TimeStamp',
    filterPlaceholder: 'Search Log Date',
    width: '15%',
    template: 'DateTimeTpl',
    Filter: 'DateFilter',
  },
  Status: {
    field: 'Status',
    filterPlaceholder: 'Search Status',
    width: '12%',
  },
  ConnectionType: {
    field: 'ConnectionType',
    filterPlaceholder: 'Search Protocol',
    width: '12%',
  },
  RemoteIpAddress: {
    field: 'RemoteIpAddress',
    filterPlaceholder: 'Search IP Address',
    width: '12%',
  },
  EmailAddress: {
    field: 'EmailAddress',
    filterPlaceholder: 'Search Email Address',
    width: '24%',
  },
  SignalRClientId: {
    field: 'SignalRClientId',
    filterPlaceholder: 'Search Client Id',
    width: '25%',
  },
};
